export function toYouTubeEmbed(url: string): string {
  const match = url.match(
    /(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))([^"&?/\s]{11})/,
  );
  return match ? `https://www.youtube.com/embed/${match[1]}` : url;
}
